export function getPostLoginRoute(user, cliente) {
  if (cliente?.isBlock) return '/auth/suspend';
  if (user.level === 'root') return '/dashboard/home';

  const hasChats = user.rules?.includes('chats');
  const hasChatInterno = user.rules?.includes('chat_interno');

  if (hasChatInterno && !hasChats) return '/chats/staff';
  if (!hasChatInterno && !hasChats) return '/dashboard/home';
  return '/chats/chat';
}
